import { PoweredBy } from "./PoweredBy";

/**
 * Minimal page footer used on inner pages (AR Preview, Receipt, Reservations,
 * Cancel, Success). The Shop landing has its own richer footer.
 */
export const PageFooter = () => (
  <footer
    data-testid="page-footer"
    className="mt-auto px-5 sm:px-10 lg:px-14 py-8 border-t border-[var(--kb-border)] flex flex-wrap items-center justify-between gap-4"
  >
    <div className="kb-mono-label text-[var(--kb-fg-2)]">
      © 2026 KISUBIKA · LONDON
    </div>
    <PoweredBy />
  </footer>
);
